import '@patsnap-ui/icon/assets/solid/chain.svg'
import type { ISourceInfo } from '@patsnap/synapse_common_interface'
import { extractSourceInfo } from '@patsnap/synapse_domain'
import '@pharmsnap/shared/src/assets/icon-svg/fileCommon.svg'
import '@pharmsnap/shared/src/assets/icon-svg/fileHtml.svg'
import '@pharmsnap/shared/src/assets/icon-svg/fileImg.svg'
import '@pharmsnap/shared/src/assets/icon-svg/filePdf.svg'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { useDomainCtx } from '@pharmsnap/shared/src/composition/useDomainCtx'
import { attachmentTypeConfigMap, usePreviewAttachment } from '@pharmsnap/shared/src/composition/usePreviewAttachment'
import { EMPTY_PLACEHOLDER } from '@pharmsnap/shared/src/constants'
import { sharedCtx } from '@pharmsnap/shared/src/context'
import { defineComponent, PropType } from '@vue/composition-api'
import { VNode } from 'vue/types/umd'
import { GIcon } from '../../ui/GIcon/GIcon'
import { GLimited } from '../../ui/GLimited/GLimited'
import { GTooltip } from '../../ui/GTooltip/GTooltip'
export const BSourceInfo = defineComponent({
  name: 'BSourceInfo',
  props: {
    sourceInfo: {
      type: Array as PropType<ISourceInfo[]>,
    },
    mode: {
      type: String as PropType<'icon' | 'detail'>,
      default: 'icon',
    },
    limitCount: {
      type: Number,
      default: 1,
    },
    limitMode: {
      type: String as PropType<'expand' | 'popover' | 'link'>,
      default: 'popover',
    },
    triggerPoint: {
      required: true,
      type: String as PropType<'DEV_STATUS' | 'MILESTONE' | 'DRUG_DEAL' | 'REGULATORY_REVIEW' | 'STRUCTURE'>,
    },
  },
  setup(props) {
    const { locale } = useLocale()
    const domainCtx = useDomainCtx()
    const { handlePreviewAttachment } = usePreviewAttachment()
    async function onClickAttachment(data: ISourceInfo) {
      if (!data.attachment_path) {
        return
      }
      tackingClick(data)
      await handlePreviewAttachment(data)
    }
    function tackingClick(data: ISourceInfo) {
      sharedCtx.service.tracking.trackGeneral({
        event_code: 'VIEW_DATA_SOURCE',
        trigger_point: props.triggerPoint,
        common1: data.source_url,
      })
    }
    return { domainCtx, locale, onClickAttachment, tackingClick }
  },
  methods: {
    renderSourceInfo(sourceInfo: ISourceInfo): VNode | null {
      const { label, link } = extractSourceInfo(this.domainCtx, sourceInfo)
      if (!label) {
        return null
      }
      if (link?.type === 'attachment') {
        const attachmentTypeIconName = (sourceInfo.attachment_type && attachmentTypeConfigMap[sourceInfo.attachment_type]?.icon) || 'FileCommon'
        const attachmentIcon = <GIcon size={24} class="bg-gray-40 rounded" svgName={attachmentTypeIconName}></GIcon>
        return (
          <a
            class="text-blue-default cursor-pointer hover:underline text-sm flex items-center gap-1"
            onClick={() => this.onClickAttachment(sourceInfo)}
          >
            <span class="truncate">{label}</span>
            {attachmentIcon}
          </a>
        )
      }
      if (link?.type === 'link') {
        return (
          <a
            onClick={() => {
              this.tackingClick(sourceInfo)
            }}
            class="text-blue-default hover:underline text-sm block truncate"
            href={link.url}
            target="_blank"
          >
            {label}
          </a>
        )
      }
      return <span class="text-sm block truncate">{label}</span>
    },
    renderSourceInfoList(sources: VNode[]) {
      const length = sources.length
      if (length === 1) {
        return sources[0]
      }
      return sources.map((item, index) => {
        return this.renderAddIndex(item, index, 'my-2')
      })
    },
    renderAddIndex(item: VNode, index?: number, className?: string) {
      if (index === undefined) {
        return item
      }
      return (
        <div class={['flex gap-1 truncate text-sm', className]}>
          {index >= 0 ? <span>{`${index + 1}.`}</span> : ''}
          {item}
        </div>
      )
    },
  },

  render() {
    const sourceVNodes = this.sourceInfo?.map((item) => this.renderSourceInfo(item)).filter(Boolean) as VNode[]
    if (!sourceVNodes?.length) {
      return <span>{EMPTY_PLACEHOLDER}</span>
    }
    if (this.mode === 'icon') {
      return (
        <GTooltip theme="light">
          <GIcon size={20} svgName="SolidChain" color="#1667B8" class="flex-shrink-0 mt-[2px]"></GIcon>
          <template slot="content">{this.renderSourceInfoList(sourceVNodes)}</template>
        </GTooltip>
      )
    }
    return (
      <GLimited
        mode={this.limitMode}
        items={sourceVNodes}
        limit={this.limitCount}
        inline={true}
        appendToBody={true}
        truncate={true}
        popoverInline={false}
        gap={{ x: 4, y: 4, trigger: 4 }}
        nestedDialog={false}
        scopedSlots={{
          default: ({ item, index, isRenderInPopover }: { item: any; index: number; isRenderInPopover: boolean }) => {
            const showIndex = sourceVNodes.length > 1 && (isRenderInPopover || (!isRenderInPopover && this.limitCount > 1))
            return this.renderAddIndex(item, showIndex ? index : undefined)
          },
        }}
      ></GLimited>
    )
  },
})
